import { KioskNotificationType } from '@biteinc/enums';

export function getProcessingNameFromNotificationType(
  notificationType: KioskNotificationType,
): string {
  switch (notificationType) {
    case KioskNotificationType.RestartApp:
      return 'Restarting';
    case KioskNotificationType.AppLogout:
    case KioskNotificationType.AppLogin:
    case KioskNotificationType.RequestLogs:
    case KioskNotificationType.RequestScreenshot:
    case KioskNotificationType.RequestStatus:
    case KioskNotificationType.LiveViewClick:
    case KioskNotificationType.LiveViewScroll:
      return 'Requesting';
    case KioskNotificationType.UpdatePaymentTerminal:
    case KioskNotificationType.ConfigUpdate:
    case KioskNotificationType.MenuUpdate:
    case KioskNotificationType.AppUpdate:
      return 'Updating';
    case KioskNotificationType.EnableAsam:
      return 'Enabling';
    case KioskNotificationType.DisableAsam:
      return 'Disabling';
    case KioskNotificationType.TestPrint:
    case KioskNotificationType.RunSpeedTest:
    case KioskNotificationType.RunWhitelistTest:
    case KioskNotificationType.RebootPaymentTerminal:
    case KioskNotificationType.ReturnToConfig:
      return 'Sending Command';
    case KioskNotificationType.UploadPaymentTerminalLogs:
      return 'Uploading';
    case KioskNotificationType.BuildUpdateChromeOs:
    case KioskNotificationType.BuildUpdateGarcon:
    case KioskNotificationType.BuildUpdateVitrine:
    case KioskNotificationType.KioskUpdate:
    case KioskNotificationType.MenuUpdateNoChange:
    case KioskNotificationType.PaymentTerminalStatusUpdate:
    case KioskNotificationType.RefundRequest:
      throw new Error('This notification type cannot be triggered by a user');
  }
}
